/* ##################### MOCK API MODELS ####################### */

export enum MarketingCtaLayoutApiModel {
  Left = 'ALIGNED_LEFT',
  Right = 'ALIGNED_RIGHT',
}

export enum MarketingDetailLayoutApiModel {
  AlignedLeft = 'ALIGNED_LEFT',
  AlignedRight = 'ALIGNED_RIGHT',
  Centered = 'CENTERED',
}

export enum MarketingEmailLayoutApiModel {
  AlignedLeft = 'ALIGNED_LEFT',
  AlignedRight = 'ALIGNED_RIGHT',
  Centered = 'CENTERED',
}

export enum MarketingMultipleContentLayoutApiModel {
  Portrait = 'PORTRAIT',
  Landscape = 'LANDSCAPE',
}

export enum StudioPageItemLayoutApiModel {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL',
}

/* ##################### MOCK API MODELS END ####################### */
